/**
 * UranIA PA — `/login` (redirect a `/accedi`).
 *
 * Fusione A.4.2 (Riordino della mappa delle rotte §4): "il padre non può
 * essere anche una terza variante dei figli" — questa rotta duplicava
 * `/login/pa` (stesso pubblico, meno curata) invece di fare da bivio.
 * Il componente `LoginPage` (hero split-screen + `SpidButton`/
 * `AltIdentityButton`) è stato rimosso, non solo scollegato: era
 * ridondante con `/login/pa`, tenerlo in giro come codice morto non
 * aveva senso. `SpidButton`/`AltIdentityButton`/`startFederatedLogin`
 * restano in uso da `/login/beneficiari`.
 */

import { createRoute, redirect } from '@tanstack/react-router';

import { Route as PubblicoRoute } from './_pubblico.tsx';

export const Route = createRoute({
  getParentRoute: () => PubblicoRoute,
  path: '/login',
  beforeLoad: () => {
    throw redirect({ to: '/accedi', replace: true });
  },
});
